const Cookie = {
  // 设置本地存储数据
  set(name: string, value: string, days?: number) {
    let domain, date, expires;
    const host = location.host;
    if (days) {
      date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    } else {
      expires = "";
    }
    if (host.split(".").length === 1) {
      document.cookie = `${name}=${value}${expires}; path=/`;
    } else {
      domain = `.${getDomain()}`;
      document.cookie = `${name}=${value}${expires}; path=/; domain=${domain}`;
      if (this.get(name) === null || this.get(name) !== value) {
        domain = `.${host}`;
        document.cookie = `${name}=${value}${expires}; path=/; domain=${domain}`;
      }
    }
  },
  // 获取本地存储数据
  get(name: string, source?: string) {
    source = source || document.cookie;
    const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
    const arr = source.match(reg);
    if (arr) {
      return decodeURIComponent(arr[2]);
    }
    return null;
  },
  // 移除本地存储数据
  remove(name: string) {
    const exp = new Date(0).toUTCString();
    const cval = this.get(name);
    if (cval !== null) {
      const host = location.host;
      if (host.split(".").length === 1) {
        document.cookie = `${name}=0;path=/;expires=${exp}`;
      } else {
        const domain = `.${getDomain()}`;
        document.cookie = `${name}=0;path=/;expires=${exp};domain=${domain}`;
      }
    }
  },
};

// 获取一级域名
function getDomain() {
  return location.host.split(".").slice(-2).join(".");
}

export default Cookie;
